import { render } from "./emailInbox.vue?vue&type=template&id=b9d39dae"
import script from "./emailInbox.vue?vue&type=script&lang=js"
export * from "./emailInbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__